// Order detail (/pages/order?id=N). Chờ ink:api:ready → fetch
// /orders/{id} → render full 1:1 (account.order_details) + reorder + receipt 再発行.
// Giá = yen thuần từ API (toLocaleString). Escape text động (XSS). Fail-open.

(function () {
  'use strict';

  function boot() {
    const root = document.querySelector('[data-ink-order]');
    if (!root) return;
    const box = root.querySelector('[data-order-detail]');
    const notFound = root.querySelector('[data-order-notfound]');
    const cfg = window.INK_ORDER || {};

    const params = new URLSearchParams(window.location.search);
    const orderId = parseInt(params.get('id'), 10);
    if (!orderId) { showNotFound(); return; }

    // Toast sau khi cancel thành công: cancel → reload (toast trước reload sẽ mất)
    // → flag sessionStorage, hiện toast ở lần load lại này.
    const CANCEL_TOAST_KEY = 'ink:order:cancel-toast';
    if (sessionStorage.getItem(CANCEL_TOAST_KEY)) {
      sessionStorage.removeItem(CANCEL_TOAST_KEY);
      window.inkToast?.('ご注文をキャンセルしました。');
    }

    const fmt = (n) => Number(n || 0).toLocaleString('ja-JP');
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

    function showNotFound() {
      if (box) box.classList.add('hidden');
      if (notFound) notFound.classList.remove('hidden');
    }

    // `rendered` = đã có nội dung đơn trên màn. Lần load lại (sau 承認) mà lỗi thì
    // GIỮ nội dung đang hiện — hạ màn 「注文が見つかりません」 lên sau một thao tác vừa
    // thành công là báo sai trạng thái. inkApi._fetch không throw khi lỗi mạng
    // (api-client.js:344 trả `{data:null,error}`) nên phải chặn ở cả 2 nhánh.
    let rendered = false;

    async function load() {
      let json;
      try {
        json = await window.inkApi.get(`/orders/${orderId}`);
      } catch (e) {
        console.warn('order detail fetch fail', e);
        if (!rendered) showNotFound();
        return;
      }
      const d = json && json.data;
      if (!d) {
        if (!rendered) showNotFound();
        return;
      }
      render(d);
      rendered = true;
    }

    function render(d) {
      const h = d.header || {};
      const t = d.totals || {};
      const p = d.payment || {};
      const s = d.shipping || {};
      const r = d.receipt || {};
      const ro = d.reorder || {};

      // ---- items (design card style; 自由選択 breakdown = <details>) ----
      const itemsHtml = (d.items || []).map((it) => {
        // プレゼント品: order_item_name có prefix「[プレゼント品]」(Joomla PRESENT_LABEL) + giá 0.
        const isPresent = it.price === 0 || /プレゼント/.test(it.name || '');
        // Tên = LUÔN xanh (design: mọi tên là link xanh). Item mất url → span xanh (không click),
        // KHÔNG render đen đậm (tránh 1 dòng đậm khác các dòng còn lại).
        const nameEl = it.url
          ? `<a href="${esc(it.url)}" class="ik-anywhere font-bold text-ink-blue">${esc(it.name)}</a>`
          : `<span class="ik-anywhere font-bold text-ink-blue">${esc(it.name)}</span>`;
        const imgInner = it.image
          ? `<img class="h-32 w-full object-contain" src="${esc(it.image)}" alt="${esc(it.name)}" loading="lazy"${it.sku ? ` data-item-stock-img data-sku="${esc(it.sku)}"` : ''}>`
          : '<span class="flex h-32 w-full items-center justify-center bg-gray-100 text-[10px] text-gray-400">画像準備中</span>';
        const imgEl = it.url ? `<a href="${esc(it.url)}" class="block">${imgInner}</a>` : imgInner;

        // プレゼント品 (design order-detail.html): ảnh + tên + プレゼント数 + cột phải「プレゼント品」xám.
        // KHÔNG sku / 参考価格 / breakdown (khớp design, tránh dòng thừa).
        if (isPresent) {
          return `
          <div class="grid gap-4 rounded border border-ink-grayLine p-4 lg:grid-cols-[150px_minmax(0,1fr)_180px] lg:items-start">
            ${imgEl}
            <div class="min-w-0">
              ${nameEl}
              <p class="mt-3 text-sm font-bold">プレゼント数：${it.quantity}</p>
            </div>
            <p class="text-right text-sm font-bold text-gray-500">プレゼント品</p>
          </div>`;
        }

        // 参考価格 + %お得: hiện khi có price_ref (>0). %お得 HIỆN CẢ KHI ÂM (nhất quán PDP save_pct).
        const refPct = it.price_ref > 0 ? 100 - Math.round(it.price / it.price_ref * 100) : 0;
        const ref = it.price_ref > 0
          ? `<p class="mt-2 text-xs text-gray-600">純正より${it.select_flg ? '最大' : ''}${refPct}%お得<br>（参考価格：${fmt(it.price_ref)}円）</p>`
          : '';
        const breakdown = (it.children || []).length
          ? `<details class="mt-3 rounded border border-ink-grayLine bg-gray-50 p-3 text-sm leading-6" open>
               <summary class="cursor-pointer font-bold text-ink-blue">選択した商品</summary>
               <p class="mt-2">${(it.children || []).map((c) => `［選択品］${esc(c.name)} ${c.quantity}本`).join('<br>')}</p>
             </details>`
          : '';
        const skuLine = esc(it.sku) ? `<div class="mt-1 text-xs text-gray-500">${esc(it.sku)}</div>` : '';
        return `
          <div class="grid gap-4 rounded border border-ink-grayLine p-4 lg:grid-cols-[150px_minmax(0,1fr)_180px] lg:items-start">
            ${imgEl}
            <div class="min-w-0">
              ${nameEl}
              ${skuLine}
              ${esc(it.attribute) ? '<div class="mt-1 text-xs text-gray-500">' + esc(it.attribute) + '</div>' : ''}
              ${breakdown}
              <p class="mt-3 text-sm font-bold">購入数：${it.quantity}</p>
            </div>
            <div class="text-right">
              <p class="text-sm text-gray-600">税込</p>
              <p class="text-3xl font-bold text-ink-red">${fmt(it.price)}<span class="text-base">円</span></p>
              ${ref}
            </div>
          </div>`;
      }).join('');

      // ---- helpers (design card / dl / totals grid) ----
      const H2 = (label) => `<h2 class="border-l-8 border-ink-green pl-3 text-xl font-bold">${esc(label)}</h2>`;
      const dl = (rows) => {
        const list = rows.filter(Boolean);
        const n = list.length;
        const cells = list.map(([k, v], i) => {
          // border-ink-grayLine LUÔN có → border-r/border-b cùng xám (dòng cuối không đen đậm).
          const b = i === n - 1 ? '' : 'border-b';
          return `<dt class="border-ink-grayLine ${b} bg-gray-50 px-4 py-3 font-bold text-gray-700 sm:border-r">${esc(k)}</dt><dd class="border-ink-grayLine ${b} px-4 py-3">${v}</dd>`;
        }).join('');
        return `<dl class="grid overflow-hidden rounded border border-ink-grayLine text-sm sm:grid-cols-[180px_1fr]">${cells}</dl>`;
      };
      const totalRow = (label, val, big) => {
        const lc = big ? 'bg-gray-50 px-4 py-3 text-right text-lg font-bold' : 'bg-gray-50 px-4 py-2 text-right font-bold';
        const vc = big ? 'px-4 py-3 text-right text-xl font-bold text-ink-red' : 'px-4 py-2 text-right';
        return `<div class="grid grid-cols-[1fr_160px] border-b border-ink-grayLine"><div class="${lc}">${esc(label)}</div><div class="${vc}">${val}</div></div>`;
      };

      // ---- order info dl (注文番号 / 注文日 / ステータス + tracking + security) ----
      // Badge status: E (お支払期限切れ) → đỏ.
      const statusBadgeCls = h.status_code === 'E' ? 'bg-red-50 text-ink-red' : 'bg-gray-100';
      // Nút 注文をキャンセル cạnh status — chỉ khi server trả cancel_enabled=true
      // (port cancelEnable gate — account.order_details.tpl.php:386-403). Bấm → modal
      // confirm [data-cancel-modal] (markup tĩnh trong section).
      const cancelBtn = d.cancel_enabled
        ? ' <button type="button" data-order-cancel class="ml-2 inline-flex min-h-8 items-center rounded border border-ink-red bg-red-50 px-3 text-xs font-bold text-ink-red">注文をキャンセル</button>'
        : '';
      // Nút 承認 đứng cạnh 注文ステータス 承認待ち (thay vì cuối khối 配達先) — cha đọc
      // trạng thái là thấy luôn việc cần làm. Style đỏ như Joomla ps_order:1246-1252.
      const approveBtn = d.can_approve
        ? ` <button type="button" data-approve="${h.order_id}" class="ml-2 inline-flex min-h-8 items-center rounded border border-[#ff0000] bg-ink-approve px-3 text-xs font-bold text-white">注文を承認する</button>`
        : '';
      const orderInfoRows = [
        ['注文番号', esc(h.order_number)],
        ['注文日', new Date(h.cdate * 1000).toLocaleDateString('ja-JP')],
        ['注文ステータス', `<span class="rounded ${statusBadgeCls} px-3 py-1 font-bold">${h.status_label || ''}</span>${cancelBtn}${approveBtn}`],
        h.takyu_num ? ['お荷物伝票番号', `${esc(h.takyu_num)}${h.tracking_url ? ' ⇒ <a href="' + esc(h.tracking_url) + '" target="_blank" rel="noopener" class="text-ink-blue underline">配達状況を確認</a>' : ''}`] : null,
        (h.security_num || h.security_pending) ? ['認証番号', h.security_num ? esc(h.security_num) : '表示までしばらくお待ち下さい。'] : null,
      ];

      // ---- totals grid ----
      const y2 = (n) => fmt(n) + '円';
      const totalRows = [
        ['小計', y2(t.subtotal)],
        t.bulk_discount ? ['割引', y2(t.bulk_discount)] : null,
        ['送料', y2(t.shipping)],
        // order_discount ÂM = 決済手数料 (代引き 330 / コンビニ 220 — ADR-032) → hiện số dương;
        // DƯƠNG = discount thật → hiện dấu trừ (account.order_details.tpl.php:498-503)
        (t.fee && t.fee.amount) ? [t.fee.label || '手数料', y2(-t.fee.amount)] : null,
        t.point_discount ? ['使用ポイント分', y2(-Math.abs(t.point_discount))] : null,
        t.coupon_discount ? ['使用クーポン分', y2(-Math.abs(t.coupon_discount))] : null,
      ].filter(Boolean).map(([l, v]) => totalRow(l, v)).join('');
      const addPointRow = t.add_point ? `<div class="grid grid-cols-[1fr_160px]"><div class="bg-gray-50 px-4 py-2 text-right font-bold">付与ポイント</div><div class="px-4 py-2 text-right">${fmt(t.add_point)}pt</div></div>` : '';

      // ---- payment ----
      const payDepr = p.deprecated_notice ? `<p class="mt-1.5 text-xs text-ink-red">${esc(p.deprecated_notice)}</p>` : '';
      const paySub = p.sub_label ? `（${esc(p.sub_label)}）` : '';

      // コンビニ決済: 払込番号/確認番号 + link hướng dẫn (KOMOJU — 4.9 §6.2).
      // API trả null khi không phải conveni hoặc chưa lấy được số → không render dòng nào.
      const cv = p.conveni;
      // KOMOJU chưa phát hành số → `number` rỗng: bỏ hẳn dòng số (nhãn rỗng khó hiểu
      // hơn là không có gì) và đổi câu nhắc sang "xem trang hướng dẫn".
      const hasNumber = !!(cv && cv.number);
      // Đơn đã huỷ: 払込番号 đã bị huỷ ở KOMOJU nên không dùng được nữa — ẩn cả khối,
      // để lại chỉ khiến khách tưởng vẫn phải đi trả.
      const conveniRows = cv && h.status_code !== 'X'
        ? [
            ...(hasNumber ? [[cv.number_label || '払込番号', `<span class="font-bold">${esc(cv.number)}</span>`]] : []),
            ...(cv.confirmation_number ? [['確認番号', `<span class="font-bold">${esc(cv.confirmation_number)}</span>`]] : []),
            ...(cv.limit_date ? [['お支払期限', esc(cv.limit_date)]] : []),
            ...(cv.instructions_url
              ? [['お支払い手順', `<a class="text-ink-blue underline" href="${esc(cv.instructions_url)}" target="_blank" rel="noopener">コンビニでのお支払い方法を見る</a>`]]
              : []),
            // Chỉ nhắc khi đơn CÒN trả được (status A/B). Đơn đã nhập kim, hết hạn (E)
            // hay đã huỷ (X) → số vẫn hiện để tra cứu nhưng không giục đi trả.
            ...(cv.payable
              ? [['お支払いについて', hasNumber
                  ? '<span class="text-ink-red">お支払いがまだの場合は、上記の番号でコンビニにてお支払いください。</span>'
                  : '<span class="text-ink-red">お支払いがまだの場合は、上記のページでお支払い番号をご確認の上、コンビニにてお支払いください。</span>']]
              : []),
          ]
        : [];

      // ---- shipping address ----
      const addr = s.address || {};
      const addrHtml = addr.same_as_member
        ? '会員情報と同じ'
        : `${esc(addr.name)}<br>〒${esc(addr.zip)} ${esc(addr.address)}<br>TEL: ${esc(addr.tel)}`;
      const deliveryRows = [
        ['配達先', addrHtml],
        (s.carrier || s.type_label) ? ['配送業者', s.carrier ? `${esc(s.carrier)}（${esc(s.type_label)}）` : esc(s.type_label)] : null,
        (s.deliver_date || s.deliver_time) ? ['配送日時', `配達日：${esc(s.deliver_date) || '指定なし（最短のお届け）'}<br>配達時間：${esc(s.deliver_time) || '指定なし（最短のお届け）'}`] : null,
        s.delivery_box ? ['宅配ボックス', 'あり'] : null,
        ['送料', y2(t.shipping)],
      ];

      // ---- receipt + reissue (giữ hook data-receipt-name / data-receipt-reissue) ----
      // Cha xem đơn tk con (ADR-038) → ẩn 領収書の宛名 + 但し書き + 再発行 (tpl
      // account.order_details.tpl.php:818 ẩn cả khối); 備考欄 vẫn hiện như Joomla.
      const receiptRows = [
        d.is_child_order ? null : ['領収書の宛名', esc(r.name) || '—'],
        d.is_child_order ? null : ['但し書き', esc(r.proviso) || '—'],
        r.customer_note ? ['備考欄', esc(r.customer_note)] : null,
      ];
      const reissue = r.reissue_enabled
        ? `<div class="mt-4 flex flex-wrap items-end gap-2">
             <label class="text-sm font-bold">宛名 <input type="text" data-receipt-name value="${esc(r.name)}" class="ml-1 min-h-10 w-[220px] rounded border border-ink-grayLine px-3"></label>
             <button type="button" data-receipt-reissue class="min-h-10 rounded bg-gray-700 px-4 text-sm font-bold text-white">領収証を再発行</button>
           </div>`
        : '';
      // Đơn con không 備考欄 → cả khối rỗng, KHÔNG render <dl> viền trống.
      const receiptBlock = receiptRows.filter(Boolean).length ? `<div>${dl(receiptRows)}${reissue}</div>` : '';

      // ---- reorder (giữ hook data-reorder / data-reorder-mode / data-reorder-msg) ----
      let reorderHtml = '';
      if (ro.eligible) {
        reorderHtml = `
          <div class="flex flex-wrap gap-3" data-reorder>
            <button type="button" data-reorder-mode="append" class="min-h-11 rounded bg-ink-orange px-5 font-bold text-white">同じ商品をまとめてカートに入れる</button>
            <div data-reorder-msg role="alert" class="w-full text-sm"></div>
          </div>`;
      } else if (ro.error_msg) {
        reorderHtml = `<p class="text-sm text-ink-red">${esc(ro.error_msg)}</p>`;
      }

      // ---- お支払い元 (billing) — dl gộp cả 支払い方法 (design payment-source) ----
      const bl = d.billing || {};
      const billingRows = [
        ['メールアドレス', esc(bl.email) || '—'],
        ['お支払い元', esc(bl.name) || '—'],
        ['ご住所', bl.address ? ((bl.zip ? '〒' + esc(bl.zip) + ' ' : '') + esc(bl.address)) : '—'],
        ['お電話番号', esc(bl.phone) || '—'],
        ['FAX', esc(bl.fax) || '—'],
        ['お支払い方法', `${esc(p.method_label)}${paySub}${payDepr}`],
        ...conveniRows,
      ];

      // ---- 関連商品 aside — 1 khối / mỗi category trong đơn (API trả list; else 1 cột) ----
      // d.related = [{category_id, title, products}]. Fallback object cũ + non-array → fail-open.
      const relGroups = (Array.isArray(d.related) ? d.related : (d.related && d.related.products ? [d.related] : []))
        .filter((g) => g && g.products && g.products.length);
      const relCard = (rp) => {
        const u = esc(rp.url || '#');
        const imgInner = rp.image
          ? `<img class="h-28 w-full object-contain" src="${esc(rp.image)}" alt="${esc(rp.name)}" loading="lazy">`
          : '<span class="flex h-28 w-full items-center justify-center bg-gray-100 text-[10px] text-gray-400">画像準備中</span>';
        return `<article><a href="${u}" class="block">${imgInner}</a><a class="ik-anywhere mt-2 block text-sm font-bold text-ink-blue" href="${u}">${esc(rp.name)}</a><p class="mt-1 font-bold text-ink-red">税込 ${fmt(rp.price)}円</p></article>`;
      };
      const relatedAside = relGroups.length
        ? `<div class="grid gap-6 lg:self-start" data-component="order-related-products">
             ${relGroups.map((g) => `<aside class="account-card rounded p-5">
               <h2 class="text-lg font-bold">${esc(g.title)}</h2>
               <div class="mt-4 grid gap-4">${g.products.map(relCard).join('')}</div>
             </aside>`).join('')}
           </div>`
        : '';

      // ---- 未払いアラート (design order-unpaid-alert) ----
      // Chỉ status E = お支払期限切れ (Joomla ConveniFinalize: A + payment 12期限切れ → E).
      // Status A (お支払い待ち, còn trả được) đã có banner hub /orders/pending-payment — không alert ở đây.
      const mypageUrl = (window.INK_ORDER && window.INK_ORDER.mypageUrl) || '/pages/mypage';
      const backLink = `<a class="inline-flex min-h-11 items-center justify-center rounded border border-ink-blue bg-white px-5 font-bold text-ink-blue no-underline" href="${esc(mypageUrl)}#navi_buy">注文履歴一覧へ</a>`;
      const unpaidActions = ro.eligible
        ? `<div class="mt-4 flex flex-wrap gap-3" data-reorder>
             <button type="button" data-reorder-mode="append" class="min-h-11 rounded bg-ink-green px-5 font-bold text-white">まとめてカートに入れる</button>
             ${backLink}
             <div data-reorder-msg role="alert" class="w-full text-sm"></div>
           </div>`
        : `<div class="mt-4 flex flex-wrap gap-3">${backLink}</div>`;
      const unpaidAlert = h.status_code === 'E'
        ? `<section class="mt-6 rounded border border-ink-red bg-red-50 p-5" data-component="order-unpaid-alert">
             <h2 class="text-xl font-bold text-ink-red">この注文は未払いです</h2>
             <p class="mt-2 text-sm leading-6 text-gray-800">お支払い期限を過ぎているため、同じ商品をまとめてカートに入れて再購入してください。</p>
             ${unpaidActions}
           </section>`
        : '';

      box.innerHTML = `
        <div class="border-b-2 border-ink-black pb-3">
          <h1 class="border-l-8 border-ink-green pl-3 text-2xl font-bold">注文情報 : 注文番号 ${esc(h.order_number)}</h1>
        </div>
        <div data-order-approve-msg role="alert" class="mt-4" hidden></div>
        ${unpaidAlert}

        <div class="mt-6 grid gap-6${relatedAside ? ' lg:grid-cols-[minmax(0,1fr)_320px]' : ''}">
          <section class="grid gap-6">
            <article class="account-card rounded p-5">
              ${H2('ご注文情報')}
              <div class="mt-4">${dl(orderInfoRows)}</div>
            </article>

            <article class="account-card rounded p-5">
              ${H2('ご注文商品')}
              <div class="mt-4 grid gap-4">${itemsHtml}</div>
              <div class="mt-5 overflow-hidden rounded border border-ink-grayLine text-sm" data-component="order-totals">
                ${totalRows}
                ${totalRow('合計（税込）', y2(t.total), true)}
                ${addPointRow}
              </div>
            </article>

            <article class="account-card rounded p-5">
              ${H2('お支払い元')}
              <div class="mt-4">${dl(billingRows)}</div>
            </article>

            <article class="account-card rounded p-5">
              ${H2('配達先・配送業者・その他')}
              <div class="mt-4 grid gap-5 lg:grid-cols-2">
                ${dl(deliveryRows)}
                ${receiptBlock}
              </div>
            </article>

            ${reorderHtml}
          </section>
          ${relatedAside}
        </div>`;

      wireReorder();
      wireReissue();
      wireApprove();
      wireCancel();
      hydrateItemImages();
    }

    // Ảnh item theo getImageUrlForEmpty (account.order_details.tpl.php:505): keep_image
    // giữ ảnh gốc; 販売終了 → soldout ưu tiên hơn 欠品 → stockout. /stock lỗi → giữ ảnh gốc.
    async function hydrateItemImages() {
      const imgs = [...box.querySelectorAll('[data-item-stock-img][data-sku]')];
      const skus = [...new Set(imgs.map((img) => img.dataset.sku))];
      const stocks = {};
      for (let i = 0; i < skus.length; i += 50) {
        try {
          const j = await window.inkApi.get('/stock', { skus: skus.slice(i, i + 50).join(',') });
          Object.assign(stocks, (j && j.data && j.data.items) || {});
        } catch (e) { console.warn('order item stock fail', e); break; }
      }
      imgs.forEach((img) => {
        const st = stocks[img.dataset.sku];
        if (!st || st.keep_image === true) return;
        if (st.buy_enable === false && cfg.soldoutImg) img.src = cfg.soldoutImg;
        else if (st.status === 'out_of_stock' && cfg.stockoutImg) img.src = cfg.stockoutImg;
      });
    }

    // 承認 đơn tk con (アソシエイツ) — thành công thì render lại detail để status +
    // nút cập nhật. Banner kết quả phải render TRƯỚC khi reload vì reload ghi đè box.
    function wireApprove() {
      const btn = box.querySelector('[data-approve]');
      if (!btn) return;
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        const ok = await window.inkOrderApprove?.run(orderId, box.querySelector('[data-order-approve-msg]'));
        if (!ok) { btn.disabled = false; return; }
        const msg = box.querySelector('[data-order-approve-msg]')?.outerHTML || '';
        await load();
        // load() dựng lại toàn bộ box → chèn lại banner vừa hiện.
        const slot = box.querySelector('[data-order-approve-msg]');
        if (slot && msg) slot.outerHTML = msg;
      });
    }

    // 注文キャンセル (port account.order_details.tpl.php:386-418 orderCancel/orderCancelPopup):
    // nút → modal confirm → OK gọi POST /orders/{id}/cancel. Server đổi trạng thái
    // đơn ngay trong request đó → thành công thì reload để render lại từ data mới
    // + toast qua sessionStorage.
    // Lỗi (422 このご注文はキャンセルできません…) → hiện message tiếng Nhật của server
    // trong modal VÀ dưới nút キャンセル ở trang: modal có thể đã bị đóng nên chỉ ghi
    // vào modal thì khách không thấy gì.
    function wireCancel() {
      const btn = box.querySelector('[data-order-cancel]');
      const modal = root.querySelector('[data-cancel-modal]');
      if (!btn || !modal) return;
      const errEl = modal.querySelector('[data-cancel-error]');
      const confirmBtn = modal.querySelector('[data-cancel-confirm]');
      // Đang gửi request huỷ: chặn bấm/đóng lần hai — gọi API 2 lần là 2 lần huỷ.
      let sending = false;

      // Vùng lỗi cạnh nút trên trang (ngoài modal) — khách luôn thấy dù modal đã đóng.
      const pageErrEl = document.createElement('p');
      pageErrEl.className = 'mt-2 hidden text-sm font-bold text-ink-red';
      pageErrEl.setAttribute('role', 'alert');
      btn.insertAdjacentElement('afterend', pageErrEl);

      const showError = (msg) => {
        errEl.textContent = msg;
        errEl.classList.remove('hidden');
        pageErrEl.textContent = msg;
        pageErrEl.classList.remove('hidden');
      };

      const open = () => {
        errEl.textContent = '';
        errEl.classList.add('hidden');
        pageErrEl.textContent = '';
        pageErrEl.classList.add('hidden');
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        modal.setAttribute('aria-hidden', 'false');
      };
      const close = () => {
        if (sending) return; // request đang bay → không cho đóng
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        modal.setAttribute('aria-hidden', 'true');
      };

      btn.addEventListener('click', () => { if (!sending) open(); });
      // Đóng: nút × / 戻る / click backdrop (cùng pattern cart-added-modal)
      modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-cancel-close]') || e.target === modal) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.classList.contains('hidden')) close();
      });

      confirmBtn.addEventListener('click', async () => {
        if (sending) return;
        sending = true;
        confirmBtn.disabled = true;
        btn.disabled = true;
        window.inkProcessing?.show();
        let json;
        try {
          json = await window.inkApi.post(`/orders/${orderId}/cancel`);
        } catch (e) {
          console.warn('order cancel fail', e);
        }
        if (json && json.data && json.data.cancelled) {
          sessionStorage.setItem(CANCEL_TOAST_KEY, '1');
          window.location.reload(); // overlay + nút disabled giữ tới khi trang load lại
          return;
        }
        window.inkProcessing?.hide();
        sending = false;
        confirmBtn.disabled = false;
        btn.disabled = false;
        showError((json && json.error && json.error.message) || (json && json.message) || 'キャンセルできませんでした。');
      });
    }

    function wireReorder() {
      // Có thể có 2 block reorder (alert 未払い + cuối trang) → wire tất cả.
      box.querySelectorAll('[data-reorder]').forEach(wireReorderBlock);
    }

    function wireReorderBlock(blockEl) {
      const msg = blockEl.querySelector('[data-reorder-msg]');
      blockEl.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-reorder-mode]');
        if (!btn) return;
        const mode = btn.dataset.reorderMode;
        msg.textContent = '処理中...';
        window.inkProcessing?.show();
        const json = await window.inkApi.post(`/orders/${orderId}/reorder`, { mode });
        if (!json || !json.data) {
          msg.textContent = (json && json.message) || '再注文できません';
          msg.style.color = '#f00';
          window.inkProcessing?.hide();
          return;
        }
        const items = json.data.lines.map((l) => ({ id: l.variant_id, quantity: l.quantity }));
        try {
          if (mode === 'replace') {
            await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
          }
          // Check res.ok: 422 (sold-out/invalid) KHÔNG throw → phải bắt thủ công,
          // tránh báo "カートに追加しました" giả / redirect tới cart trống.
          const addRes = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }),
          });
          if (!addRes.ok) throw new Error('cart add not ok');
        } catch (err) {
          console.warn('reorder cart add fail', err);
          msg.textContent = 'カート追加に失敗しました';
          msg.style.color = '#f00';
          window.inkProcessing?.hide();
          return;
        }
        if (mode === 'replace') {
          window.location.href = cfg.cartUrl || '/cart'; // overlay giữ tới khi chuyển trang
        } else {
          msg.textContent = 'カートに追加しました';
          msg.style.color = '#00a040';
          document.dispatchEvent(new CustomEvent('ink:cart:updated'));
          document.dispatchEvent(new CustomEvent('ink:cart:added')); // mở modal COMMON (đồng nhất site)
          window.inkProcessing?.hide();
        }
      });
    }

    function wireReissue() {
      const btn = box.querySelector('[data-receipt-reissue]');
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const nameInput = box.querySelector('[data-receipt-name]');
        const name = nameInput ? nameInput.value.trim() : '';
        const qs = name ? `?change_name=${encodeURIComponent(name)}` : '';
        btn.textContent = '生成中...';
        window.inkProcessing?.show('領収証を生成中...');
        try {
          const blob = await window.inkApi.fetchBlob(`/orders/${orderId}/receipt.pdf${qs}`);
          // Download file thẳng (mirror 領収証 phát hành = tải về)
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `領収証_${orderId}.pdf`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          setTimeout(() => URL.revokeObjectURL(url), 60000);
        } catch (e) {
          console.warn('receipt pdf fail', e);
          alert('領収証の発行に失敗しました');
        } finally {
          btn.textContent = '領収証を再発行';
          window.inkProcessing?.hide();
        }
      });
    }

    load();
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) {
    startOnce();
  } else {
    document.addEventListener('ink:api:ready', startOnce, { once: true });
    window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000));
  }
})();
